"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var MeterCounter = function MeterCounter(props) {
  var classes = props.hasError ? 'text-center ano-meter-counter__text__error' : 'text-center ano-meter-counter__text';
  var pathDescription = 'M18 2C9.201 2 2 9.201 2 18s7.201 16 16 16 ' + '16-7.201 16-16S26.799 2 18 2zm0 30c-7.7 0-14-6.3-14-14S10.3 4 18 ' + '4s14 6.3 14 14-6.3 14-14 14z';
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "ano-meter-counter row"
  }, props.hasError && /*#__PURE__*/_react.default.createElement("div", {
    className: "svg-bckgrd"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    className: "ano-meter-error-container__error",
    xmlns: "http://www.w3.org/2000/svg",
    width: "36",
    height: "36",
    viewBox: "0 0 36 36"
  }, /*#__PURE__*/_react.default.createElement("g", {
    fill: "#F3463F",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: pathDescription
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17 24h2v2h-2zM18.6 22h-1.2l-.4-6.857V10h2v5.143L18.6 22"
  })))), /*#__PURE__*/_react.default.createElement("h4", {
    className: classes
  }, "".concat(props.meterCounterLabel, " ").concat(props.index, " von ").concat(props.amount)));
};
var _default = exports.default = MeterCounter;